import { GetterTree } from 'vuex';
import { ImportState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ImportState, RootState> = {

}